import { Labels, ChartDatasetsObject } from "@/app/model/chart";
import { Product } from "@/app/model";
import { EventNodeAPI } from "@/app/model/interface/event-node";
import {AdditionalChartData} from "@/app/standAlone/performance/chart/chart.component";
import { createTargetLines } from "./utilities";

export const chartData = (
    labels: Labels,
    baseline: ChartDatasetsObject[] = [],
    target: ChartDatasetsObject[] = [],
    targetLowerBound: ChartDatasetsObject[] = [],
    targetUpperBound: ChartDatasetsObject[] = [],
    demand: ChartDatasetsObject[] = [],
    gradient: any,
    eventNode: EventNodeAPI,
    product: Product,
    additionalChartData: AdditionalChartData,
    axisEndMs: number | null
) => {
  const targetObj = createTargetLines(labels.target, target, targetLowerBound, targetUpperBound, gradient, eventNode, product);
  return {
    datasets: [
      {
        label: labels.baseline,
        data: baseline,
        borderColor: "rgb(245,86,0)",
        stepped: false,
        backgroundColor: "rgb(245,86,0)",
        pointRadius: 0,
        tension: 0,
        lineGroup: true,
        borderWidth: 2
      },
      {
        label: labels.demand,
        data: demand,
        borderColor: "rgb(70,30,125)",
        stepped: false,
        backgroundColor: "rgb(70,30,125)",
        pointRadius: 0,
        lineGroup: true,
        tension: 0,
        borderWidth: 2
      },
      ...targetObj,
      {
        label: 'Ghost Axis Keeper',
        data: [
          { x: additionalChartData.chartStartTime.toISOString(), y: null },
          // No known end (event still pending): anchor to the latest data point plus
          // post-ramping-period room instead of the (unknown) event end.
          ...(axisEndMs != null ? [{ x: new Date(axisEndMs).toISOString(), y: null }] : []),
        ],
        pointRadius: 0,
        borderWidth: 0,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        stepped: false,
        hoverRadius: 0,
        tension: 0,
        lineGroup: true,
        tooltip: { enabled: false }, // Hide from tooltips
      },
    ],
  }
};
